module.exports = __webpack_public_path__ + "static/media/MyselfImage.c32e699e.svg";